<template lang="pug">
  el-table(
    style="width: 100%;"
    header-cell-class-name='table-header'
    cell-class-name='pl-4'
    :data="snoozeNotifications"
  )
    el-table-column(
      prop="sensor_transmitter"
      :label="$t('snooze_notifications.label.sensor_transmitter')"
      width="180px"
    )
      template(slot-scope='scope')
        span {{ scope.row.soil_sensor.transmitter_name }}
    el-table-column(
      prop="sensor_transmitter"
      :label="$t('snooze_notifications.label.soil_sensor')"
      width="140px"
    )
      template(slot-scope='scope')
        span {{ scope.row.soil_sensor.name }}
    el-table-column(
      prop="sensor_transmitter"
      :label="$t('snooze_notifications.label.info_type')"
      width="130px"
    )
      template(slot-scope='scope')
        span {{ scope.row.info_type }}
    el-table-column(
      prop="created_at"
      :label="$t('snooze_notifications.label.ends_at')"
    )
      template(slot-scope='scope')
        span(v-if='scope.row.ends_at') {{ computeDate12HourFormat(scope.row.ends_at) }}
        span(v-else) -
    el-table-column(
      prop="created_at"
      :label="$t('snooze_notifications.label.created_at')"
    )
      template(slot-scope='scope')
        span(v-if='scope.row.created_at') {{ computeDate12HourFormat(scope.row.created_at) }}
        span(v-else) -
    el-table-column(
      prop="seen"
      :label="$t('snooze_notifications.label.actions')"
    )
      template(slot-scope='scope')
        .grid-buttons
          el-button.dark-green-btn.pop-up-btn(
            @click="handleEditSnoozeForNotification(scope.row)"
            :loading="loading"
          ) {{ $t('snooze_notifications.actions.change') }}
          img.cursor-pointer.mr-2(
            src="@assets/actions/delete.svg"
            @click="handleDeleteSnoozeForNotification(scope.row)"
            :loading="loading"
          )
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { filterUtils } from "@utils/filterUtils";
export default {
  name: 'SnoozeNotificationsTable',
  mixins: [filterUtils],

  props: {
    snoozeNotifications: {
      type: Array
    },
  },

  data() {
    return {
      loading: false,
    }
  },
  created() {

  },
  methods: {
    ...mapMutations("dialog", [ "showEditSnoozeNotificationDialog" ]),
    ...mapMutations("snoozeNotification", [ "setSnoozeNotification", "setShouldFetchSnoozeNotifications" ]),

    ...mapActions("snoozeNotification", ["deleteSnoozeNotification"]),

    handleEditSnoozeForNotification(notification){
      this.setSnoozeNotification(notification);
      this.showEditSnoozeNotificationDialog();
    },

    async handleDeleteSnoozeForNotification(snoozeNotification) {
      this.loading = true;
      this.setShouldFetchSnoozeNotifications(false);
      this.deleteSnoozeNotification(snoozeNotification.id)
        .then(() => {
          this.setShouldFetchSnoozeNotifications(true);
        })
        .catch((error) => {
          // this.setAllowDeletion(false);
        })
        .finally(() => {
          // this.setLoading(false);
          this.loading = false;
        });
        this.loading = false;
    },

  }
}
</script>

<style lang="scss" scoped>
.grid-buttons {
  display: flex;
  // flex-wrap: wrap;
  flex-direction: row;
  gap: 5px;
}
</style>